<script lang="ts">
  import { enPropriétéWebC } from '$plateforme/webComponent';
  import { creeLienContactsUtiles } from '../contacts/contacts';
  import { profilStore } from '../stores/profil.store';
  import { détecteRendu } from '../utils/rendu.svelte';

  let estConnecte = () => !!$profilStore;

  const rendu = détecteRendu();

  const cheminRelatif: string = typeof window !== 'undefined' ? window.location.pathname : '/';

  const itemDeMenu = (label: string, href: string, active: boolean) => ({
    label,
    id: `nav-${label.toLowerCase().replaceAll(' ', '-')}`,
    href,
    active,
  });

  const lienParcoursUtilisateur = $derived(
    $profilStore?.parcoursSecurisation.parcoursActuel === null
      ? '/parcours-securisation'
      : $profilStore?.parcoursSecurisation.parcoursActuel === 'allégé'
        ? '/modules/1'
        : '/parcours-complet'
  );
  const lienParcoursSécurisation = $derived(estConnecte() ? lienParcoursUtilisateur : '/parcours-securisation');
  const menu = $derived([
    ...(rendu.estMobile ? [itemDeMenu('Accueil', '/', cheminRelatif === '/')] : []),

    itemDeMenu(
      '🚀 Protéger mon organisation',
      lienParcoursSécurisation,
      ['/parcours-securisation', '/parcours-cyberdepart', '/parcours-complet'].includes(cheminRelatif) ||
        ['/modules/', '/mesures/'].some((lien) => cheminRelatif.startsWith(lien))
    ),

    itemDeMenu(
      'Faire le test !',
      '/faire-le-test',
      ['/faire-le-test', '/test-maturite', '/ma-maturite', '/session-groupe', '/exposition'].includes(cheminRelatif) ||
        ['/vrai-faux', '/reflexes-cyber-en-ligne'].some((lien) => cheminRelatif.startsWith(lien))
    ),

    itemDeMenu(
      'Guides et ressources',
      '/catalogue',
      cheminRelatif === '/catalogue' ||
        cheminRelatif.startsWith('/guides/') ||
        cheminRelatif.startsWith('/ressources/') ||
        cheminRelatif.startsWith('/services/')
    ),

    ...(estConnecte() ? [itemDeMenu('Favoris', '/favoris', cheminRelatif === '/favoris')] : []),

    {
      label: 'Contacts et financements',
      id: 'nav-contacts',
      type: 'menu',
      collapsable: true,
      collapseId: 'nav-contacts',
      active:
        ['/contacts', '/prestataires-labellises', '/financements'].includes(cheminRelatif) ||
        cheminRelatif.startsWith('/financements/') ||
        cheminRelatif.startsWith('/contacts'),
      items: [
        itemDeMenu('Contacts cyber', creeLienContactsUtiles($profilStore), cheminRelatif.startsWith('/contacts')),
        itemDeMenu(
          'Prestataires qualifiés et labellisés',
          '/prestataires-labellises',
          cheminRelatif === '/prestataires-labellises'
        ),
        itemDeMenu(
          'Financements',
          '/financements',
          cheminRelatif === '/financements' || cheminRelatif.startsWith('/financements/')
        ),
      ],
    },

    ...(rendu.estMobile ? [itemDeMenu('Directive NIS 2', '/nis2', cheminRelatif === '/nis2')] : []),
  ]);
</script>

<dsfr-navigation items={enPropriétéWebC(menu)}>
  {#if rendu.estBureau}
    <a href="/nis2" class="bouton-nis2" slot="afternavigation">
      <img src="/assets/images/badge-nis2.svg" alt="Directive NIS2" />
    </a>
  {/if}
</dsfr-navigation>

<style lang="scss">
  dsfr-navigation:not(:defined) .bouton-nis2 {
    display: none;
  }

  .bouton-nis2 {
    border-top: 1px solid var(--border-default-grey);
    background-color: var(--yellow-moutarde-975, #fef5e8);
    width: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0;

    &:hover {
      background: var(--yellow-moutarde-975-75-hover);
    }
    &:active {
      background: var(--yellow-moutarde-975-75-active);
    }
  }
</style>
